module.exports = __webpack_public_path__ + "img/update-content.f43d1d9d.png";